<div class="wrapper cv-dialog-form organization-container">
	<div class="row">
		<div class="col-sm-12">
			<cv-input
				(controlKeyup)="config.nexsysAttribute = $event.value.trim()"
				[value]="config.nexsysAttribute"
				[label]="'Data Message Attribute'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[placeholder]="'Data Message Attribute'"
			></cv-input>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				[label]="'AppScope'"
				[placeholder]="'Select a type'"
				[options]="dataMessageTypeOptions"
				[selectedValue]="config.appScopeType"
				(valuesChange)="onAppScopeTypeSelected($event)"
			>
			</cv-dropdown>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				[label]="'Acuity'"
				[placeholder]="'Select a type'"
				[options]="dataMessageTypeOptions"
				[selectedValue]="config.acuityType"
				(valuesChange)="onAcuityTypeSelected($event)"
			>
			</cv-dropdown>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				[label]="'CMP Acuity'"
				[placeholder]="'Select a type'"
				[options]="dataMessageTypeOptions"
				[selectedValue]="config.cmpAcuityType"
				(valuesChange)="onCmpAcuityTypeSelected($event)"
			>
			</cv-dropdown>
		</div>
	</div>
</div>
